import {
  AngelouCSS,
  ComboboxStyleOverrides,
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  breakpoints: { BreakpointNames },
  colors: { ui },
} = constants;

export const createStandardFilterCss: ComboboxStyleOverrides<AngelouCSS> = {
  root: {
    marginBottom: "8px",
    input: {
      display: "flex",
      height: "42px",
      maxWidth: "216px",
      color: ui.neutral[700],
      ...typographyStyles.textMObj,

      border: `1px solid ${ui.neutral[200]}`,
      borderRadius: "0.5rem",

      "::placeholder": {
        ...typographyStyles.textMObj,
        color: ui.neutral[500],
      },
    },
    ul: {
      zIndex: 3,
    },
    label: {
      ...typographyStyles.fontSize.textXS,
      svg: {
        display: "none",
      },
    },
    [mediaQueryStyles.mediaQuery.upTo(BreakpointNames.sm)]: {
      width: "100%",
      input: {
        width: "100%",
        maxWidth: "100%",
      },
    },
  },
};
